module.exports = __webpack_public_path__ + "static/img/icon2.502a147.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon2.png
// module id = PM2Y
// module chunks = 0